export default function authHeader(api_endpoint = false, api_endpoint_prefix = "layer_common", has_multimedia = false) {
  let user = JSON.parse(localStorage.getItem("user"));

  let headerParam = {};
  headerParam['endpoint'] = api_endpoint;
  headerParam['reference'] = api_endpoint_prefix;
  if (user && user.data.token) {
    headerParam['Authorization'] = "Bearer " + user.data.token;
  }
  if(has_multimedia){
    headerParam['Content-Type'] = 'multipart/form-data';
  }else{
    headerParam['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  return headerParam;
}
